<template>
    <div class="header-feedback"
        :style="{
            background: colors.theme == 'dark' ? colors[colors.theme].to : '#191919'
        }"
    >
        <!-- <div class="index-header">
            <span class="index">{{index + 1}}.</span>
        </div> -->
        <div class="logo-huddle">
            <img src="/img/logo/logo-huddle-quadrado.png" alt="logo Huddle">
        </div>
        <div class="logo-decode">
            <logoDecode></logoDecode>
        </div>
        <div class="progress-header">
            <div class="progress-container">
                <div class="progress" :style="progress"></div>
            </div>
            <span class="desc-progress">{{Math.trunc(percent)}}{{$t("components.feedback.HeaderFeedback.descProgress")}}</span>
        </div>
    </div>
</template>
<script>
import logoDecode from '../../components/Shared/CustomIcons/Header/logoDecode'
export default {
    components: {logoDecode},
    data(){
        return{
            percent : 0,
            colors: {}
        }
    },
    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
    },    
    props:{
        index: {
            type : Number,
            required : true
        },
        steps: {
            type : Number,
            required : true
        }
    },
    computed: {
        progress(){
            this.calculePercent(this.index)
            let stepWidth = ((100 / this.steps))
            let progressWidth = (stepWidth * this.index) + 3
            return `width : ${progressWidth}%`
        }
    },
    methods: {
        calculePercent(index){
            let stepWidth = ((100 / this.steps))
            this.percent = `${(stepWidth * this.index)}`
        }
    }
}
</script>
<style lang="scss" scoped>
    .header-feedback{
        height: 10vh;
        background: rgb(155,254,248);
        // background: linear-gradient(100deg, rgba(155,254,248,1) 0%, rgba(61,240,229,1) 100%);
        position: relative;
        padding: 0 23px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;        

        .logo-huddle, .logo-decode{
            display: flex;
            align-items: center;
            img{
                width: 40px;
            }
            svg{
                width: 90px;
            }
        } 
        
        .logo-huddle{
            width: 10%;
        }
        .logo-decode{
            width: 30%;
            margin-left: 15px;
        }

        .index-header{

            width: 30%;
            height: 100%;
            display: flex;
            align-items: center;
            margin-left: 5%;

            .index{

                font-size: 30px;
                font-weight: bold;
                color: white;
                text-shadow: 2px 2px 2px rgb(48, 187, 175);
            }
        }

        .progress-header{

            width: 100%;
            height: 100%;
            top: -10px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            flex-direction: column;
            align-items: flex-end;
            position: relative;

            .progress-container{

                width: 70%;
                height: 7px;
                background-color: #2d2d2d;

                .progress{

                    background-color: white;
                    height: 100%;
                    max-width: 100%;
                    border-radius: 300px;
                }
            }

            .desc-progress{

                font-size: 12px;
                text-transform: uppercase;
                letter-spacing: 2px;
                font-weight: bold;
                color: white;
                margin: 10px 0 15px;
            }
        }
    }
    @media only screen and (min-width : 750px) {
        .header-feedback{
            height: 7vh;
        }
        .header-feedback .progress-header .progress-container{
            width: 50%
        }
        
    }
</style>
